import React from 'react';
import { Image, Text } from '@fluentui/react';
import { createControlComponent } from "@react-leaflet/core";
import { Marker, Popup, useMap } from 'react-leaflet';
import { LatLng } from 'leaflet';

import 'leaflet';
import "leaflet-routing-machine";

declare let L : any;

interface ILeafletMapMarkerWaypointComponentProps {
    startCoordinates: LatLng;
    endCoordinates: LatLng;
    iconStartUrl: string;
    iconEndUrl: string;
    titleStart: string;
    textStart: string;
    titleEnd: string;
    textEnd: string;
    waypointStartIconUrl: string;
    waypointEndIconUrl: string;
};

const LeafletMapMarkerWaypointComponent = (props: ILeafletMapMarkerWaypointComponentProps) => {
    const map = useMap();

    const RoutineMachine = createControlComponent(() => {
        const instance = L.Routing.control({
            waypoints: [
                props.startCoordinates,
                props.endCoordinates,
            ],
            lineOptions: {
                styles: [
                    {
                        color: '#ed6d63', 
                        opacity: 1, 
                        weight: 5,
                    },
                ],
                addWaypoints: false,
            },
            createMarker: function() { 
                return null;
            },
        });

        setTimeout(() => {
            map.setZoom(8);
        }, 1000);

        return instance;
    });

    const getStartIcon = () : L.Icon => {
        if (props.waypointStartIconUrl) {
            return L.icon({
                iconSize: [25, 40],
                iconAnchor: [10, 40],
                popupAnchor: [2, -40],
                iconUrl: props.waypointStartIconUrl,
            });
        }
        else {
            return L.icon({
                iconSize: [25, 41],
                iconAnchor: [10, 41],
                popupAnchor: [2, -40],
                iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
                shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
            });
        }
    };

    const getEndIcon = () : L.Icon => {
        if (props.waypointEndIconUrl) {
            return L.icon({
                iconSize: [25, 40],
                iconAnchor: [10, 40],
                popupAnchor: [2, -40],
                iconUrl: props.waypointEndIconUrl,
            });
        }
        else {
            return L.icon({
                iconSize: [25, 41],
                iconAnchor: [10, 41],
                popupAnchor: [2, -40],
                iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
                shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
            });
        }
    };
    
    return (
        <>
            {
                props.startCoordinates ? (
                    <Marker
                        position={props.startCoordinates}
                        icon={getStartIcon()}>
                        <Popup>
                            <div className='row align-items-center m-0'>
                                <div className='col-auto p-0'>
                                    {
                                        props.iconStartUrl ? (
                                            <Image src={props.iconStartUrl} height={30} width={30} />
                                        ) : (
                                            null
                                        )
                                    }
                                </div>
                                <div className='col p-0'>
                                    <Text variant="medium">
                                        <strong>
                                            {props.titleStart}
                                        </strong>
                                    </Text>
                                </div>
                                <div className='col-12 p-0'>
                                    <Text>
                                        {props.textStart}
                                    </Text>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.endCoordinates ? (
                    <Marker
                        position={props.endCoordinates}
                        icon={getEndIcon()}>
                        <Popup>
                            <div className='row align-items-center m-0'>
                                <div className='col-auto p-0'>
                                    {
                                        props.iconEndUrl ? (
                                            <Image src={props.iconEndUrl} height={30} width={30} />
                                        ) : (
                                            null
                                        )
                                    }
                                </div>
                                <div className='col p-0'>
                                    <Text variant="medium">
                                        <strong>
                                            {props.titleEnd}
                                        </strong>
                                    </Text>
                                </div>
                                <div className='col-12 p-0'>
                                    <Text>
                                        {props.textEnd}
                                    </Text>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                (props.startCoordinates && props.endCoordinates && props.startCoordinates !== props.endCoordinates) ? (
                    <RoutineMachine />
                ) : (
                    null
                )
            }
        </>
    );
};

export default LeafletMapMarkerWaypointComponent;
